<div class="tool-panel-content">
    <button class="button-with-image" *ngFor="let shape of shapes" (click)="addShape(shape.name);">
        <svg *ngIf="shape.type === 'Path'" xmlns="http://www.w3.org/2000/svg" viewBox="0 -100 512 700">
            <path [attr.d]="shape.options.path" [attr.stroke-width]="shape.options.strokeWidth || 10"></path>
        </svg>
        <mat-icon [svgIcon]="shape.name+'-custom'" *ngIf="shape.type !== 'Path'"></mat-icon>
        <span class="name bottom-label" trans>{{shape.name}}</span>
    </button>
</div>
